import * as Sentry from "@sentry/react";

import { toast } from "@/utils/notifications";

export const COMBINED_PROCEDURE_CODES_REBUILD_FAILURE_NOTIFICATION_ID =
  "combined-procedure-codes-rebuild-failure";

/**
 * Handles a failed best-effort background combined procedure `ValueSet` rebuild (for example
 * after custom code save/delete when durable writes already succeeded): logs, reports to Sentry,
 * and shows a non-blocking warning toast.
 *
 * @param error The rejection reason from `getOrCreateCombinedProcedureCodesValueSet` or another
 *   combined-rebuild caller.
 */
export function notifyCombinedProcedureCodesRebuildFailed(error: unknown): void {
  console.error("Error updating combined procedure codes ValueSet:", error);
  Sentry.captureException(error, {
    level: "warning",
    tags: { feature: "combined-procedure-codes" },
    extra: { operation: "background-rebuild-after-custom-code-mutation" },
  });

  toast({
    id: COMBINED_PROCEDURE_CODES_REBUILD_FAILURE_NOTIFICATION_ID,
    type: "warning",
    title: "Procedure search list may be out of date",
    message:
      "Your changes were saved, but updating the combined procedure list failed. Try saving again or reload the page. Procedure pickers may miss the latest codes until this succeeds.",
    autoClose: false,
  });
}
